<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
        <v-flex
        md12>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('subcategories.addNewSubcategory')}} {{ curretCategoryName }}</v-card-title>
        </v-card>
        <v-spacer/>
            <v-form ref="addCategoryForm">
              <v-card-text>
                  <v-container grid-list-md mt-12>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="subcategoryName"
                            :label="$t('subcategories.name')"
                            :placeholder="$t('subcategories.name')"
                            :error-messages="subcategoryNameErrors"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-select
                            v-model="products"
                            :items="getAllProducts"
                            :label="$t('subcategories.products')"
                            :placeholder="$t('subcategories.products')"
                            item-text="title"
                            item-value="id"
                            multiple
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sku"
                            :label="$t('subcategories.sku')"
                            :placeholder="$t('subcategories.sku')"
                            :error-messages="skuErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sortBoxNo"
                            :label="$t('subcategories.sortBoxNo')"
                            :placeholder="$t('subcategories.sortBoxNo')"
                            :error-messages="sortBoxNoErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="metaTitle"
                            :label="$t('subcategories.metaTitle')"
                            :placeholder="$t('subcategories.metaTitle')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md9>
                        <v-text-field
                            v-model="metaDescription"
                            :label="$t('subcategories.metaDescription')"
                            :placeholder="$t('subcategories.metaDescription')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaKeywords"
                            :label="$t('subcategories.metaKeywords')"
                            :placeholder="$t('subcategories.metaKeywords')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaUrl"
                            :label="$t('subcategories.metaUrl')"
                            :placeholder="$t('subcategories.metaUrl')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaImage"
                            :label="$t('subcategories.metaImage')"
                            :placeholder="$t('subcategories.metaImage')"
                          />
                      </v-flex>
                        <v-flex xs12 sm6 md2>
                            <v-checkbox
                                v-model="isActiveWeb"
                                :label="$t('subcategories.web')"
                            ></v-checkbox>
                      </v-flex>
                      <v-flex s12 xs12 sm6 md2>
                            <v-checkbox
                                v-model="isActiveMobile"
                                :label="$t('subcategories.mobile')"
                            ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <v-label-field>{{ $t('subcategories.image') }}</v-label-field><br>
                            <input id="subcategory-image" type='file' accept="image/*"/><br>
                            <img id="subcategoryImage">
                      </v-flex>
                        <v-flex xs12 sm6 md3>
                            <v-color-picker v-model="color"
                                    mode="hexa"
                                    hide-mode-switch></v-color-picker>
                            <!-- <span>{{ showColor }}</span> -->
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="cancelSubcategory()">{{ $t('cancel')}}</v-btn>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark

                        @click="createSubcategory()">{{ $t('submit')}}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required, numeric } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  import axios from 'axios'
  import Vue from 'vue'

  export default {
      data () {
          return {
            subcategoryName: '',
            products: [],
            sku: '',
            sortBoxNo: '',
            metaTitle: '',
            metaDescription: '',
            metaKeywords: '',
            metaUrl: '',
            metaImage: '',
            isActiveWeb: false,
            isActiveMobile: false,
            type: 'hex',
            hex: '#FF00FF',
            curretCategoryName: localStorage.getItem('categoryName')
          }
      },
      validations: {
          subcategoryName: { required },
          sku: { required },
          sortBoxNo: { required, numeric }
      },
      computed: {
        ...mapGetters([
            'getAllProducts'
        ]),
        color: {
            get () {
                return this[this.type];
            },
            set (v) {
                    this[this.type] = v;
                },
        },
        showColor () {
            if (typeof this.color === 'string') return this.color

            return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
                color[key] = Number(this.color[key].toFixed(2))
                return color
            }, {}), null, 2)
        },
        subcategoryNameErrors(){
            const errors = [];
                if (!this.$v.subcategoryName.$dirty) return errors;
                    !this.$v.subcategoryName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        skuErrors(){
            const errors = [];
                if (!this.$v.sku.$dirty) return errors;
                    !this.$v.sku.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        sortBoxNoErrors(){
            const errors = [];
                if (!this.$v.sortBoxNo.$dirty) return errors;
                    !this.$v.sortBoxNo.numeric && errors.push(i18n.tc('fieldValueNumber'));
                    !this.$v.sortBoxNo.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        }
      },
      methods: {
        resetSubcategoryForm(){
            this.$refs.addCategoryForm.reset();
            this.$v.$reset();
        },
        cancelSubcategory(){
            this.resetSubcategoryForm();
            this.$router.go(-1);
        },
        createSubcategory(){
          const subcategoryFile = document.getElementById('subcategory-image').files[0],
                categoryId = localStorage.getItem('categoryId');

          let formData = new FormData();
              formData.append('parent_id', categoryId);

              if (subcategoryFile) {
                formData.append('image', subcategoryFile);
              }

              formData.append('sku', this.sku);
              formData.append('position', this.sortBoxNo);
              formData.append('enable_mobile', this.isActiveMobile);
              formData.append('enable_web', this.isActiveWeb);
              formData.append('color', this.showColor);
              formData.append('translations[0][name]', this.subcategoryName);
              formData.append('translations[0][meta_title]', this.metaTitle);
              formData.append('translations[0][meta_description]', this.metaDescription);
              formData.append('translations[0][meta_keywords]', this.metaKeywords);
              formData.append('translations[0][meta_url]', this.metaUrl);
              formData.append('translations[0][meta_image]', this.metaImage);
              formData.append('translations[0][language_identifier]', 'sr');
              for (var i = 0; i < this.products.length; i++) {
                  formData.append('product_ids[]', this.products[i]);
              }

            if(this.$v.subcategoryName.$invalid || this.$v.sku.$invalid
                || this.$v.sortBoxNo.$invalid){
                this.$v.$touch();
                return;
            } else {
                return new Promise((resolve) => {
                axios.post(`category`, formData)
                  .then(resp => {
                    if(!resp.data.error){
                          Vue.toasted.show(i18n.tc(`successfully`),{
                              theme: 'outline',
                              singleton: true,
                              position:'top-center',
                              action :
                                {
                                    text : i18n.tc(`ok`),
                                    onClick : (e, toastObject) => {
                                        toastObject.goAway(0);
                                        this.$router.go(-1);
                                    }
                                }
                          });
                          this.$store.dispatch('LOAD_ALL_CATEGORIES')
                    } else {
                      console.log(resp.data.error)
                    }
                  resolve(resp)
                })
              })
            }
        },
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
      mounted() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
  }
</script>

<style lang="less">

</style>
